import {
  ClassIntegrationScreen,
  DefectsScreen,
  defectsRoute,
  HistoryScreen,
  InstructionsTab,
  MaintenancePlanScreen,
  PmsLibraryScreen,
  PostponementsScreen,
  SetupChangesScreen,
  WorkOrdersScreen,
} from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { officeClassIntegrationSource } from '../class-integration-source.js';
import { Shell } from '../components/Shell.js';
import { officeDefectsSource } from '../defects-source.js';
import { officePmsLibrarySource } from '../pms-library-source.js';
import { officePmsSource } from '../pms-source.js';
import { useOfficeDocuments } from './DocumentPages.js';

/**
 * Maintenance (PMS) ▸ Maintenance Plan (ortak ekran; M7b3 Task 14a): ofis planı ve görev
 * kütüphanesini görür; iş tanımını yalnız kurulum devrinde yazar (K1); ertelemenin ve aralık
 * uzatmasının ofis adımını parolayla verir (K10, K11).
 */
export function PmsPlanPage() {
  const { t } = useTranslation();
  const documents = useOfficeDocuments();
  return (
    <Shell title={t('menu.pmsPlan')}>
      <MaintenancePlanScreen
        source={officePmsSource}
        // Instructions sekmesi (K38): ofis taslak yükler, DPA onaylar ve yayınlar
        instructions={<InstructionsTab source={documents} />}
      />
    </Shell>
  );
}

/**
 * Maintenance (PMS) ▸ Postponements (ortak ekran; ADR 0108 §4): onay gemide biter; ofis gemi ve
 * filo listesinde izler, yorum yazar, ertelemeyi geri çevirir ya da yeni vade verir.
 */
export function PmsPostponementsPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.pmsPostponements')}>
      <PostponementsScreen source={officePmsSource} />
    </Shell>
  );
}

/**
 * Fleet ▸ Vessels ▸ Setup Changes (`/fleet/setup-changes?vessel=`; ADR 0142 §3): kurulumdaki etkin
 * gemide ofisin PMS değişiklikleri ve gemiden dönen sonuçlar. Menüde değil; Fleet satır menüsünden
 * ve PMS ekranlarındaki kurulum şeridinden açılır, menüde Vessels etkin görünür.
 */
export function SetupChangesPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('pms.setupChangeList.title')}>
      <SetupChangesScreen source={officePmsSource} />
    </Shell>
  );
}

/**
 * Maintenance (PMS) ▸ Work Orders (ortak ekran; M7b3 Task 14b): ofis iş emirlerini, kayıtları ve
 * ekleri salt okunur görür; bakım kaydı gemide yazılır (K13).
 */
export function PmsWorkOrdersPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.pmsWorkOrders')}>
      <WorkOrdersScreen source={officePmsSource} />
    </Shell>
  );
}

/**
 * Maintenance (PMS) ▸ History (ortak ekran; M7b3 Task 14d): raporlu iş kayıtları, iptal edilenler
 * ve düzeltmeler; silinen ekipman ve iş tanımının kayıtları [NR496 4.3.2a].
 */
export function PmsHistoryPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.pmsHistory')}>
      <HistoryScreen source={officePmsSource} />
    </Shell>
  );
}

/**
 * Maintenance (PMS) ▸ Defects (ortak ekran; M15e, ADR 0060): filo arıza listesi ve DM-17 kaydı;
 * ofis Part C notu yazar ve yönetim adımına karar verir. Arıza gemide yazılır.
 */
export function PmsDefectsPage() {
  const { t } = useTranslation();
  const { search } = useLocation();
  return (
    <Shell title={t('menu.pmsDefects')}>
      <DefectsScreen source={officeDefectsSource} route={defectsRoute(search)} />
    </Shell>
  );
}

/**
 * Maintenance (PMS) ▸ PMS Library (M15f; ADR 0063): şirket kütüphanesi, Excel içe aktarma, Felix
 * şablonu ve gemiye uygulama sihirbazı. Etkin gemide uygulama talep olarak gemiye iner.
 */
export function PmsLibraryPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.pmsLibrary')}>
      <PmsLibraryScreen
        source={officePmsLibrarySource}
        today={new Date().toISOString().slice(0, 10)}
      />
    </Shell>
  );
}

/**
 * Maintenance (PMS) ▸ Class Integration (DNV MAD; ortak 2026-10-28; ADR 0132): ayar ve anahtarlar,
 * ekipman eşlemesi, önizleme ve doğrulama, aktarımlar ve indirme. Yalnız ofiste.
 */
export function PmsClassIntegrationPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.pmsClassIntegration')}>
      <ClassIntegrationScreen source={officeClassIntegrationSource} />
    </Shell>
  );
}
